<div class="connect-property-container">

  <div style="position: sticky; top: 0;background-color: #161616; z-index: 1; color: #DEDEDE;">
    <div
      style="display: flex;justify-content: space-between;align-items: center;border-bottom: 1px solid rgba(222, 222, 222, 0.2);padding: 32px;">
      <div class="title">Connected Properties</div>
      <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color" style="cursor: pointer;"
        (click)="cancel()">close</mat-icon>
    </div>
    <div class="filter-box" fxLayout="row wrap" fxLayoutGap="16px" fxLayoutAlign="start center">
      <!-- <mat-form-field appearance="outline" class="no-padding">
        <input matInput [(ngModel)]="filterParams.unitNum" placeholder="Property Name">
      </mat-form-field> -->
      <mat-form-field appearance="outline" class="no-padding">
        <mat-label style="color: #DEDEDE;">Bedroom Number</mat-label>
        <mat-select [(value)]="filterParams.bedRoom" (selectionChange)="filterProperties()">
          <mat-option [value]="0">any</mat-option>
          <mat-option [value]="1">1</mat-option>
          <mat-option [value]="2">2</mat-option>
          <mat-option [value]="3">3</mat-option>
          <mat-option [value]="4">4</mat-option>
          <mat-option [value]="5">5+</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="no-padding">
        <mat-label style="color: #DEDEDE;">Bathroom number</mat-label>
        <mat-select [(value)]="filterParams.bathRoom" (selectionChange)="filterProperties()">
          <mat-option [value]="0">any</mat-option>
          <mat-option [value]="1">1</mat-option>
          <mat-option [value]="2">2</mat-option>
          <mat-option [value]="3">3</mat-option>
          <mat-option [value]="4">4</mat-option>
          <mat-option [value]="5">5+</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="no-padding">
        <mat-label style="color: #DEDEDE;">Car space</mat-label>
        <mat-select [(value)]="filterParams.carParking" (selectionChange)="filterProperties()">
          <mat-option [value]="0">any</mat-option>
          <mat-option [value]="1">1</mat-option>
          <mat-option [value]="2">2</mat-option>
          <mat-option [value]="3">3</mat-option>
          <mat-option [value]="4">4</mat-option>
          <mat-option [value]="5">5+</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- <div style="padding-bottom: 1.34375em;">
        <button mat-flat-button (click)="filterProperties()" class="filter-button">Search</button>
      </div> -->
    </div>
  </div>

  <div class="dialog-table">
    <table mat-table [dataSource]="dataSource" style="width: 100%;" class="connect-property-table">
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox [color]="'primary'" (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </th>
        <td mat-cell 
        *matCellDef="let row; let i = index"
        [class]="{
          'checked-td': row.isChecked,
          'checked-td-b-left': row.isChecked,
          'checked-td-b-top': !dataSource[i - 1]?.isChecked,
          'checked-td-b-bottom': !dataSource[i + 1]?.isChecked
        }"
        >
          <mat-checkbox [color]="'primary'" [(ngModel)]="row.isChecked" [checked]="selection.isSelected(row)"
            [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </td>
      </ng-container>
      <ng-container matColumnDef="unit">
        <th mat-header-cell *matHeaderCellDef>
          <div class="properties-table-title">Property Name</div>
        </th>
        <td mat-cell  
        *matCellDef="let element; let i = index"
          [class]="{
            'checked-td': element.isChecked,
            'checked-td-b-top': !dataSource[i - 1]?.isChecked,
            'checked-td-b-bottom': !dataSource[i + 1]?.isChecked
          }">
    
          {{element.unitNum}}  
        </td>
      </ng-container>
      <ng-container matColumnDef="config">
        <th mat-header-cell *matHeaderCellDef>
          <div class="properties-table-title">Config</div>
        </th>
        <td mat-cell 
        *matCellDef="let element; let i = index"
          [class]="{
            'checked-td': element.isChecked,
            'checked-td-b-top': !dataSource[i - 1]?.isChecked,
            'checked-td-b-bottom': !dataSource[i + 1]?.isChecked
            
          }"
        >
          {{element.bedRoom}}/{{element.bathRoom}}/{{element.carParking}}
        </td>
      </ng-container>
      <ng-container matColumnDef="building">
        <th mat-header-cell *matHeaderCellDef>
          <div class="properties-table-title">Building</div>
        </th>
        <td mat-cell *matCellDef="let element; let i = index"
        [class]="{
          'checked-td': element.isChecked,
            'checked-td-b-top': !dataSource[i - 1]?.isChecked,
            'checked-td-b-bottom': !dataSource[i + 1]?.isChecked
        }">
          {{getProjectBuildingName(element)}}
        </td>
      </ng-container>
      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef>
          <div class="properties-table-title">Price (AUD)</div>
        </th>
        <td mat-cell *matCellDef="let element; let i = index"
        [class]="{
          'checked-td': element.isChecked,
            'checked-td-b-top': !dataSource[i - 1]?.isChecked,
            'checked-td-b-bottom': !dataSource[i + 1]?.isChecked
        }">
          <span style="cursor: pointer">A{{element.price | currency: '':'symbol':'1.0-0'}}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          <div class="properties-table-title">Status</div>
        </th>
        <td mat-cell *matCellDef="let element; let i = index"
        [class]="{
          'checked-td': element.isChecked,
            'checked-td-b-top': !dataSource[i - 1]?.isChecked,
            'checked-td-b-bottom': !dataSource[i + 1]?.isChecked,
          'checked-td-b-right': element.isChecked
        }" style="text-align: left;">
          <span style="cursor: pointer" [ngClass]="getStatusLabel(element.status)">
            ● {{getStatusLabel(element.status)}}
          </span>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
      <tr [class]="{'is-checked':row.isChecked}" class="property-row" mat-row
        *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <div fxLayout="row" fxLayoutAlign="end"
    style="padding: 32px;;position: sticky; bottom: 0;background-color: #161616; z-index: 1;">
    <button mat-flat-button (click)="cancel()"
      style="background: #161616;color:#DEDEDE;border: 1px solid #DEDEDE;border-radius: 8px;width: 163px;height: 52px;">Back</button>
    <button mat-flat-button (click)="submit()"
      style="background: #161616;color:#DEDEDE;margin-left:36px;border: 1px solid #DEDEDE;border-radius: 8px;width: 163px;height: 52px;">Save</button>
  </div>
</div>